import type { CalcTab } from '@/pages/Home'
import { NAV_ITEMS } from '@/components/layout/Sidebar'
import {Menu, X} from 'lucide-react'

interface HeaderProps {
  activeTab: CalcTab
  mobileOpen: boolean
  setMobileOpen: (v: boolean) => void
}

export default function Header({ activeTab, mobileOpen, setMobileOpen }: HeaderProps) {
  const active = NAV_ITEMS.find((i) => i.id === activeTab)

  return (
    <header
      className="sticky top-0 z-20 flex items-center gap-4 px-4 sm:px-6 py-4 border-b"
      style={{ background: 'rgba(255,251,242,0.95)', borderColor: '#e8d9b0', backdropFilter: 'blur(8px)' }}
    >
      {/* Hamburger */}
      <button
        type="button"
        onClick={() => setMobileOpen(!mobileOpen)}
        className="lg:hidden p-2 rounded-xl transition-colors"
        style={{ background: '#f5f5f4', color: '#57534e' }}
        aria-label="Toggle navigation"
      >
        {mobileOpen ? <X size={20} /> : <Menu size={20} />}
      </button>

      {/* Current page title */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          {active && (
            <span
              className="w-7 h-7 rounded-lg flex items-center justify-center"
              style={{ background: active.color + '20', color: active.color }}
            >
              {active.icon}
            </span>
          )}
          <h1 className="text-base font-bold truncate" style={{ color: '#1c1917' }}>
            {active?.seo ?? 'Mango Calculator Hub'}
          </h1>
        </div>
      </div>

      {/* Right: URL badge */}
      <a
        href="https://www.mangocalculator.com"
        className="hidden sm:flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold border transition-colors"
        style={{ background: '#fef3c7', borderColor: '#fbbf24', color: '#92400e' }}
        target="_blank"
        rel="noopener noreferrer"
      >
        🥭 mangocalculator.com
      </a>
    </header>
  )
}
